<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/controleFrota"> Família </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Controle Frota"
              v-model="descricao"
              :counter="200"
              :rules="[(v) => !!v || 'O nome é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/controleFrota" color="error" class="mr-4"> Cancelar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoControleFrota from "../../Tabs/TabControleFrota";
import { enviarControleFrotaAsync } from "../../../services/controleFrotaService";

export default {
  name: "criarControleFrota",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
  }),
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarControleFrotaAsync(this.descricao);
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/controleFrota");
        }
      }
    },
  },
  components: {
    TabNavegacaoControleFrota,
  },
};
</script>
